<template>
  <div class="ctrl-gives-points">
    <el-row>
      <el-col>
        <h2>ポイント付与</h2>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" :gutter="30">
      <el-col :span="6">
        <el-input type="number" placeholder="123" v-model="userId" min="1">
          <template slot="prepend">ユーザーID</template>
        </el-input>
      </el-col>
      <el-col :span="12">
        <el-input type="number" placeholder="100000" v-model="pointsToGive" min="1">
          <template slot="prepend">付与するポイント数</template>
        </el-input>
      </el-col>
      <el-col :span="3">
        <el-button @click="givesPoints" type="primary">実行</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  data() {
    return {
      userId: 1,
      pointsToGive: 1
    }
  },
  components: {
  },
  computed: {
    rt() {
      return this.$store.getters.rt;
    }
  },
  methods: {
    givesPoints() {
      if(this.pointsToGive > 0) {
        console.log("points OK.");
      }else {
        alert("付与するポイント数は1以上にしてください。");
        return;
      }
      if(confirm(`user_id: ${this.userId} のユーザーに${this.pointsToGive}ポイント付与します。よろしいですか？`)) {

        let params = new URLSearchParams();
        params.append("user_id", this.userId);
        params.append("points_to_give", this.pointsToGive);
        this.$axios
          .post(`${this.rt}/l/api/point/give-to-user`, params)
          .then(response => {
            console.log(response);

            // CheckCtrlUserId は未移行 (HTTP 200 + 本文 status:401) なので本文を見る
            if (response.data.status !== 401) {
              alert("付与しました。");
              return;
            } else {
              alert(response.data.message);
              return;
            }
          })
          .catch(error => {
            console.log(error);

            //
            let message = "付与できませんでした。";
            if (error.response !== undefined && error.response.data.message !== undefined) {
              message = error.response.data.message;
            } else {
              // no action.
            }
            alert(message);
            return;
          });

      }else {
        return;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
